import { ListGroup, InputGroup, Form } from "react-bootstrap";
import LableValueDisplay from "../../Client/LableValueDisplay";
import DatePicker from "../../Form/DatePicker";
import toDateOnlyDisplay from "../../../utilities/toDateOnlyDisplay";
import toDateOnly from "../../../utilities/toDateOnly";

const ListGroupTextItem = ({
  editMode,
  name,
  id,
  value,
  placeholder,
  imputtype,
  options // <-- new prop for dropdown options
}) => {
  let dValDisplay = "";
  let dVal = "";
  if (imputtype == null) imputtype = "text";
  if (imputtype === "date") {
    dValDisplay = toDateOnlyDisplay(value);
    dVal = toDateOnly(value);
  }

  return (
    <div style={{paddingLeft:"12px"}}>
      {/* Display mode */}
      {!editMode && imputtype !== "date" && imputtype !== "dropdown" && (
        <LableValueDisplay name={name} value={value} />
      )}
      {!editMode && imputtype === "date" && (
        <LableValueDisplay name={name} value={dValDisplay} />
      )}
      {!editMode && imputtype === "dropdown" && (
        <LableValueDisplay
          name={name}
          value={
            options
              ? (options.find((opt) => opt.value === value) || {}).label || value
              : value
          }
        />
      )}

      {/* Edit mode */}
      {editMode && (
        <InputGroup size="sm">
          <InputGroup.Text>{name}</InputGroup.Text>
          {imputtype === "date" && (
            <DatePicker id={id} value={dVal} placeholder="yyyy-mm-dd" />
          )}
          {imputtype === "text" && (
            <Form.Control
              id={id}
              type="text"
              defaultValue={value}
              placeholder={placeholder}
            />
          )}
          {imputtype === "dropdown" && (
            <Form.Select id={id} defaultValue={value}>
              <option value="">Select...</option>
              {options &&
                options.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
            </Form.Select>
          )}
        </InputGroup>
      )}
    </div>
  );
};

export default ListGroupTextItem;
